const CONTRACT_ERROR_I18N_KEY_BY_SUBSTRING: {
  key: string
  match: (raw: string) => boolean
}[] = [
  {
    match: (raw) => raw.includes('cannot register themselves'),
    key: 'referral.enterCodeModal.errors.selfReferral'
  },
  {
    match: (raw) =>
      raw.includes('referral for') && raw.includes('already exists'),
    key: 'toast.referral.referralLinkExists'
  },
  {
    match: (raw) => raw.includes('cap has been reached'),
    key: 'referral.enterCodeModal.errors.codeCapReached'
  },
  {
    match: (raw) => raw.includes('code is disabled'),
    key: 'referral.enterCodeModal.errors.codeDisabled'
  },
  {
    match: (raw) => raw.includes('invalid otp code'),
    key: 'connect.otpErrorInvalid'
  },
  {
    match: (raw) => raw.includes('code') && raw.includes('not found'),
    key: 'referral.enterCodeModal.errors.invalidCode'
  },
  {
    match: (raw) => raw.includes('max retries have been reached'),
    key: 'connect.otpErrorMaxRetries'
  },
  {
    match: (raw) => raw.includes('turnkeyotpauthfailed'),
    key: 'connect.otpErrorFallback'
  }
]

export function mapContractErrorToI18nKey(error: unknown): null | string {
  if (!error || typeof error !== 'object') {
    return null
  }

  const message = (error as { message?: string }).message || ''
  const originalMessage =
    (error as { originalMessage?: string }).originalMessage || ''
  const raw = `${message} ${originalMessage}`.toLowerCase()

  if (!raw.trim()) {
    return null
  }

  const match = CONTRACT_ERROR_I18N_KEY_BY_SUBSTRING.find((entry) =>
    entry.match(raw)
  )

  return match?.key ?? null
}
